import React from 'react';
import { useGoogleReviews } from '../../hooks/useGoogleReviews';
import { useCarousel } from '../../hooks/useCarousel';
import { ReviewCard } from '../reviews/ReviewCard';
import { ReviewsHeading, CarouselControls, reviewKey } from '../reviews/CarouselControls';

export const GoogleReviewsSection = () => {
  const data = useGoogleReviews();
  const reviews = data?.available ? data.reviews || [] : [];
  const { idx, go, pause, resume } = useCarousel(reviews.length);

  if (!reviews.length) return null;

  return (
    <section
      id="google-reviews"
      data-testid="google-reviews-section"
      className="py-16 sm:py-24 bg-sand-50"
      onMouseEnter={pause}
      onMouseLeave={resume}
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <ReviewsHeading rating={data.rating} totalRatings={data.totalRatings} />

        <div className="relative" data-testid="reviews-carousel">
          <div className="overflow-hidden">
            <div className="flex transition-transform duration-500 ease-out" style={{ transform: `translateX(-${idx * 100}%)` }}>
              {reviews.map((r, i) => (
                <div key={reviewKey(r, i)} className="w-full flex-shrink-0 px-2" data-testid={`review-slide-${i}`}>
                  <ReviewCard review={r} />
                </div>
              ))}
            </div>
          </div>
          {reviews.length > 1 && <CarouselControls reviews={reviews} idx={idx} go={go} />}
        </div>

        <p className="text-center text-xs text-gray-400 mt-8 max-w-2xl mx-auto">
          Reviews and ratings are provided by Google and ordered by relevance. Up to five reviews are shown.
        </p>
      </div>
    </section>
  );
};
